import { z } from "zod";
import { appIdSchema, isoTimestampSchema, opaqueRefSchema } from "./identifiers.js";
const sourceEventIdSchema = z.string().trim().min(1).max(200);
const kindSchema = z.string().trim().regex(/^[a-z][a-z0-9_]{1,99}$/);
const errorClassSchema = z.string().trim().regex(/^[a-z][a-z0-9_]{1,99}$/);
const base = {
    schemaVersion: z.literal(1),
    sourceEventId: sourceEventIdSchema,
    appId: appIdSchema,
    kind: kindSchema,
    severity: z.enum(["info", "warning", "error", "critical"]),
    scope: z.enum(["app", "platform", "unknown"]),
    title: z.string().trim().min(1).max(200),
    summary: z.string().trim().min(1).max(2_000),
    observedAt: isoTimestampSchema,
    evidenceRefs: z.array(opaqueRefSchema).max(20),
};
export const healthSignalSchema = z
    .object({
    ...base,
    source: z.literal("health"),
    context: z
        .object({
        endpointPath: z.string().trim().startsWith("/").max(500),
        statusCode: z.number().int().min(100).max(599).nullable(),
        consecutiveFailures: z.number().int().min(1).max(10_000),
    })
        .strict(),
})
    .strict();
export const verificationSignalSchema = z
    .object({
    ...base,
    source: z.literal("verification"),
    context: z
        .object({
        verificationId: z.uuid(),
        gate: z.enum(["manifest", "migration", "runtime", "browser", "live"]),
        revision: z.string().trim().min(1).max(200),
    })
        .strict(),
})
    .strict();
export const runtimeSignalSchema = z
    .object({
    ...base,
    source: z.literal("runtime"),
    context: z
        .object({
        runtimeId: z.string().trim().min(1).max(200),
        errorClass: errorClassSchema,
        retryable: z.boolean(),
    })
        .strict(),
})
    .strict();
export const functionSignalSchema = z
    .object({
    ...base,
    source: z.literal("function"),
    context: z
        .object({
        functionName: z.string().trim().min(1).max(200),
        invocationRef: opaqueRefSchema,
        errorClass: errorClassSchema,
    })
        .strict(),
})
    .strict();
export const jobSignalSchema = z
    .object({
    ...base,
    source: z.literal("job"),
    context: z
        .object({
        jobName: z.string().trim().min(1).max(200),
        invocationRef: opaqueRefSchema,
        errorClass: errorClassSchema,
    })
        .strict(),
})
    .strict();
export const agentFeedSignalSchema = z
    .object({
    ...base,
    source: z.literal("agent_feed"),
    context: z
        .object({
        alertKind: kindSchema,
        windowMinutes: z.number().int().min(1).max(10_080),
    })
        .strict(),
})
    .strict();
export const userReportSignalSchema = z
    .object({
    ...base,
    source: z.literal("user_report"),
    context: z.object({ reportId: z.uuid() }).strict(),
})
    .strict();
export const agentSignalEnvelopeSchema = z.discriminatedUnion("source", [
    healthSignalSchema,
    verificationSignalSchema,
    runtimeSignalSchema,
    functionSignalSchema,
    jobSignalSchema,
    agentFeedSignalSchema,
    userReportSignalSchema,
]);
//# sourceMappingURL=signals.js.map